import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import _ from 'lodash';
import * as forge from 'node-forge';
import { ICandidate } from '../api-client/models/candidate';

export class CandidatesVerificationHashCreator {

    public static computeHash(candidates: ICandidate[]): string {

        ArgumentValidator.notNullOrEmpty(candidates, 'candidates');

        const str = this.createConcatenatedString(candidates);

        const md = forge.md.sha256.create();

        md.update(str, 'utf8');

        return md.digest().toHex();
    }

    public static createConcatenatedString(candidates: ICandidate[]): string {

        ArgumentValidator.notNullOrEmpty(candidates, 'candidates');

        return _.map(candidates, x => {

            return `${x.id}:${x.displayName}`;

        }).join('|');
    }
}
